import { graphql } from "gql.tada";
import { ThemeFragment } from "./ThemeFragment";
import { FootnoteFragment } from "./FootnoteFragment";

export const CaseStudyBodySectionFragment = graphql(
  `
    fragment CaseStudyBodySectionFragment on CaseStudyBodySection {
      sys {
        id
      }
      title
      body {
        json
        links {
          entries {
            inline {
              sys { id }
              __typename
              ... on RichEntry {
                body { json }
              }
              ... on Footnote {
                ...FootnoteFragment
              }
            }
          }
        }
      }
      theme {
        ...ThemeFragment
      }
      imageSlidesCollection(limit: 10) {
        items {
          url
          contentType
          title
        }
      }
    }
  `,
  [ThemeFragment, FootnoteFragment]
);
